import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Sou <span className="purple"> desenvolvedora Frond-End e jornalista </span>
            de <span className="purple"> São Paulo, Brasil.</span>
            <br />Estudo Ciência e Tecnologia na Universidade Federal do ABC (UFABC) e sou formada em Comunicação pela Unesp.
            <br />
            <br />
            Além de programar, eu também adoro:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Filmes de ficção científica
            </li>
            <li className="about-activity">
              <ImPointRight /> Ler e escrever em blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Viajar
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
